<style scoped>
    .icon{
        cursor: pointer;
    }
    .picture /deep/ .ivu-modal-close .ivu-icon-ios-close{
        font-size: 50px;
        color: white;
        font-weight: bold;
        background: rgba(55,55,55,.1);
        border-radius: 50%;
    }
</style>
<template>
  <div style="display:inline;margin-right: 5px;">
    <Icon
      class="icon"
      type="ios-image-outline"
      :size="size"
      @click="showPicture"
    />
    <Modal
      v-model="show_picture"
      class="picture"
      fullscreen
      footer-hide
    >
      <div>
        <div>
          <EditAttachments 
            can-selected
            :selected-item="pictureList[index]"
            :files="pictureList"
            model-type="EpopAccountMonthlyRecord"
            :model-id="target.id"
            @clickFile="selectFile"
            @delSuccess="delSuccess"
          />
        </div>
        <div :style="contain_style">
          <div :style="img_contain">
            <img
              v-for="(item,i) in pictureList"
           
              :key="item.id"
              ref="image"
              :style="`position: absolute;left: 0px;top: 0px;width:100%;height:100%;z-index:${index===i?2:1}`"
              :src="picture_url(item.id)"
            
              @load="imgLoad(i,item)"
            >
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
  import { getsafe } from '@/libs/util';
  import EditAttachments from '@/views/components/file/edit_attachments_v1'
  export default {
    components: {
      EditAttachments
    },
    props: {
      url: {
        type: String,
      },
      pictureList: {
        type: Array
      },
      target: {
        type: Object
      },
      size: {
        type: [Number, String],
        default: 14
      }
    },
    data() {
      return {
        show_picture: false,
        loading: false,
        img_loaded: false,
        invoice: {},
        invoice_file: {},
        index: 0,
        ori_size: {},
        loading_hash: {}
      }
    },
    computed: {
      window_height() {
        const height = this.$store.state.window_height;
        return height - 100
      },
      window_width() {
        const width = this.$store.state.window_width;
        return width - 50
      },
      img_contain() {
        const target = this.pictureList[this.index]
        let height = getsafe(this.ori_size, `${target.id}.height`, 100)
        let width = getsafe(this.ori_size, `${target.id}.width`, 100)
        if (width > this.window_width) {
          height = height * (this.window_width / width)
          width = this.window_width
        }
        if (height > this.window_height) {
          width = width * (this.window_height / height)
          height = this.window_height
        }
    
        return {
          width: `${width}px`,
          height: `${height}px`,
          margin: 'auto',
          position: 'relative'
        }
      
      },
      contain_style() {
        return {
          height: `${this.window_height }px`,
          width: `${this.window_width }px`,
          margin: 'auto'
        }
      },
    
    },
    watch: {
      show_picture(val) {
        if (val) {
          document.addEventListener('keydown', this.changePic)
        } else {
          document.removeEventListener('keydown', this.changePic)
        }
      }
    },
    created() {
      //
    },
    mounted() {
      //
    },
    methods: {
      delSuccess() {
        this.$emit('success')
        this.index = 0
      },
      picture_url(id) {
        const url = `${this.url}?id=${id}`
        return url
      },
      selectFile(file) {
        this.index = this.pictureList.indexOf(file)
      },
      changePic(e) {
        switch (e.key) {
        case 'ArrowRight':
          if (this.index >= this.pictureList.length - 1) {
            this.$Message.warning('已经是最后一张！')
          } else {
            console.log('this.pictureList.length', this.index, this.pictureList.length)
            this.index++
          }
          
          break;
        case 'ArrowLeft':
          if (this.index <= 0) {
            this.$Message.warning('已经是第一张！')
          } else {
            this.index--
          }
        
          break;
        default:
          break;
        }
      },
      showPicture() {
        this.show_picture = true;
        if (this.loading) return;
        this.loading = true;
      },
      imgLoad(i, item) {
        this.img_loaded = true;
        this.$set(this.ori_size, item.id, {
          width: this.$refs.image[i].naturalWidth,
          height: this.$refs.image[i].naturalHeight,
        })
      
      },
      imgLoadStart() {
        console.log('imgloadingstart')
      }
    }
  }
</script>
